<template>
  <ul class="list-reset wrap-sub-list">
    <li class="flex items-center h-12"
      v-for="(incl, index) in inclusions"
      :key="index">
      <div class="flex-none pr-3">
        <template v-if="incl.icon">
          <img width="28" height="28" :src="incl.icon" :alt="incl.name" />
        </template>
        <template v-else>
          <div style="width: 28px">
            <svg width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_success"></use>
            </svg>
          </div>
        </template>
      </div>
      <div class="flex-1">{{ incl.name }}</div>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['inclusions']
}
</script>

<style scoped>
@media only screen and (min-width : 601px){
  .wrap-sub-list {
    display: grid;
    grid-template-columns: repeat(2,minmax(0,1fr));
  }
}
</style>
